import http from '../httpService';

const InquiryReturnationService = {
  getAllInquiryReturnationTypes: params =>
    http.get('inquiry-returnation/returnation-types', { params }),
};

export default InquiryReturnationService;
